import Vue from 'vue';

export enum MATH_IMAGE_RESOURCE_KEY {
  a         = 'a',
  b         = 'b',
  bigleft1  = 'bigleft1',
  bigleft2  = 'bigleft2',
  bigright1 = 'bigright1',
  bigright2 = 'bigright2',
  bigroot   = 'bigroot',
  blank     = 'blank',
  c         = 'c',
  div       = 'div',
  dot       = 'dot',
  equal     = 'equal',
  left1     = 'left1',
  left2     = 'left2',
  minus     = 'minus',
  n0        = 'n0',
  n1        = 'n1',
  n2        = 'n2',
  n3        = 'n3',
  n4        = 'n4',
  n5        = 'n5',
  n6        = 'n6',
  n7        = 'n7',
  n8        = 'n8',
  n9        = 'n9',
  plus      = 'plus',
  pm        = 'pm',
  right1    = 'right1',
  right2    = 'right2',
  root      = 'root',
  times     = 'times',
  u2        = 'u2',
  u3        = 'u3',
  u4        = 'u4',
  u5        = 'u5',
  u6        = 'u6',
  u7        = 'u7',
  u8        = 'u8',
  u9        = 'u9',
  x         = 'x',
  y         = 'y',
  z         = 'z',
};

const MATH_IMAGE_SIZE_MAP = new Map([
  [MATH_IMAGE_RESOURCE_KEY.a,         {width: 14, height: 28}],
  [MATH_IMAGE_RESOURCE_KEY.b,         {width: 14, height: 28}],
  [MATH_IMAGE_RESOURCE_KEY.bigleft1,  {width: 20, height: 74}],
  [MATH_IMAGE_RESOURCE_KEY.bigleft2,  {width: 24, height: 74}],
  [MATH_IMAGE_RESOURCE_KEY.bigright1, {width: 20, height: 74}],
  [MATH_IMAGE_RESOURCE_KEY.bigright2, {width: 24, height: 74}],
  [MATH_IMAGE_RESOURCE_KEY.bigroot,   {width: 26, height: 74}],
  [MATH_IMAGE_RESOURCE_KEY.blank,     {width: 64, height: 32}],
  [MATH_IMAGE_RESOURCE_KEY.c,         {width: 14, height: 28}],
  [MATH_IMAGE_RESOURCE_KEY.div,       {width: 28, height: 28}],
  [MATH_IMAGE_RESOURCE_KEY.dot,       {width: 22, height: 28}],
  [MATH_IMAGE_RESOURCE_KEY.equal,     {width: 28, height: 28}],
  [MATH_IMAGE_RESOURCE_KEY.left1,     {width: 10, height: 32}],
  [MATH_IMAGE_RESOURCE_KEY.left2,     {width: 14, height: 32}],
  [MATH_IMAGE_RESOURCE_KEY.minus,     {width: 28, height: 28}],
  [MATH_IMAGE_RESOURCE_KEY.n0,        {width: 14, height: 28}],
  [MATH_IMAGE_RESOURCE_KEY.n1,        {width: 14, height: 28}],
  [MATH_IMAGE_RESOURCE_KEY.n2,        {width: 14, height: 28}],
  [MATH_IMAGE_RESOURCE_KEY.n3,        {width: 14, height: 28}],
  [MATH_IMAGE_RESOURCE_KEY.n4,        {width: 14, height: 28}],
  [MATH_IMAGE_RESOURCE_KEY.n5,        {width: 14, height: 28}],
  [MATH_IMAGE_RESOURCE_KEY.n6,        {width: 14, height: 28}],
  [MATH_IMAGE_RESOURCE_KEY.n7,        {width: 14, height: 28}],
  [MATH_IMAGE_RESOURCE_KEY.n8,        {width: 14, height: 28}],
  [MATH_IMAGE_RESOURCE_KEY.n9,        {width: 14, height: 28}],
  [MATH_IMAGE_RESOURCE_KEY.plus,      {width: 28, height: 28}],
  [MATH_IMAGE_RESOURCE_KEY.pm,        {width: 24, height: 28}],
  [MATH_IMAGE_RESOURCE_KEY.right1,    {width: 10, height: 32}],
  [MATH_IMAGE_RESOURCE_KEY.right2,    {width: 14, height: 32}],
  [MATH_IMAGE_RESOURCE_KEY.root,      {width: 24, height: 28}],
  [MATH_IMAGE_RESOURCE_KEY.times,     {width: 28, height: 28}],
  [MATH_IMAGE_RESOURCE_KEY.u2,        {width: 12, height: 28}],
  [MATH_IMAGE_RESOURCE_KEY.u3,        {width: 12, height: 28}],
  [MATH_IMAGE_RESOURCE_KEY.u4,        {width: 12, height: 28}],
  [MATH_IMAGE_RESOURCE_KEY.u5,        {width: 12, height: 28}],
  [MATH_IMAGE_RESOURCE_KEY.u6,        {width: 12, height: 28}],
  [MATH_IMAGE_RESOURCE_KEY.u7,        {width: 12, height: 28}],
  [MATH_IMAGE_RESOURCE_KEY.u8,        {width: 12, height: 28}],
  [MATH_IMAGE_RESOURCE_KEY.u9,        {width: 12, height: 28}],
  [MATH_IMAGE_RESOURCE_KEY.x,         {width: 14, height: 28}],
  [MATH_IMAGE_RESOURCE_KEY.y,         {width: 14, height: 32}],
  [MATH_IMAGE_RESOURCE_KEY.z,         {width: 14, height: 28}],
]);

type State = {
  map: Map<MATH_IMAGE_RESOURCE_KEY, HTMLImageElement>;
};

const state = Vue.observable<State>({
  map: new Map<MATH_IMAGE_RESOURCE_KEY, HTMLImageElement>()
});

export default Vue.extend({

  name: 'MathImageMixin',

  methods: {
    async loadAllImage(): Promise<void> {
      const keys = Object.keys(MATH_IMAGE_RESOURCE_KEY);
      await Promise.all(keys.map(async key => {
        return await this.$_loadImage(key);
      }));
    },
    getImage(key: MATH_IMAGE_RESOURCE_KEY): HTMLImageElement {
      return state.map.get(key)!;
    },
    $_loadImage(key: string): Promise<void> {
      return new Promise((resolve, reject) => {
        const img = state.map.get(MATH_IMAGE_RESOURCE_KEY[key as MATH_IMAGE_RESOURCE_KEY]);
        if (img !== undefined && img.complete) return resolve(); // 画像読み込み済みの場合はresolveしてreturn

        // 画像読み込み
        const newImg = new Image();
        newImg.onload  = () => { resolve(); };
        newImg.onerror = () => { reject(); };
        newImg.width   = MATH_IMAGE_SIZE_MAP.get(MATH_IMAGE_RESOURCE_KEY[key as MATH_IMAGE_RESOURCE_KEY])!.width;
        newImg.height  = MATH_IMAGE_SIZE_MAP.get(MATH_IMAGE_RESOURCE_KEY[key as MATH_IMAGE_RESOURCE_KEY])!.height;
        newImg.src     = require(`@/assets/img/math/${key}.svg`);
        state.map.set(MATH_IMAGE_RESOURCE_KEY[key as MATH_IMAGE_RESOURCE_KEY], newImg);
      });
    }
  }

});
